export const INVOICE_FETCHED = 'INVOICE_FETCHED';
export const SET_IS_EXCHANGE = 'SET_IS_EXCHANGE';
export const SET_INVOICE_PRICE = 'SET_INVOICE_PRICE';
export const SET_INVOICE_DISCOUNT = 'SET_INVOICE_DISCOUNT';
export const SET_TEMPORARY_DISCOUNT = 'SET_TEMPORARY_DISCOUNT';
export const SET_APPOINTMENT = 'SET_APPOINTMENT';
